export default __webpack_public_path__ + "static/media/mode-520.c85d99bf.svg";